<template>
  <div>
    <esign v-show="state === 0" v-on:next="onNext" />
    <basic-info v-show="state === 1" v-on:next="onNext" v-on:prev="onPrev" />
    <addr v-show="state === 2" v-on:next="onNext" v-on:prev="onPrev" />
    <employment v-show="state === 3" v-on:next="onNext" v-on:prev="onPrev" />
    <sign
      v-show="state === 4"
      v-on:prev="onPrev"
      v-on:next="onNext"
      :state="applicationData.currentState_id"
    />
    <success
      v-show="state === 5"
      :firstName="applicationData.firstName"
      :lastName="applicationData.lastName"
    />
  </div>
</template>

<script>
import addr from "./address.vue";
import basicInfo from "./basicInfo.vue";
import employment from "./employment.vue";
import esign from "./esign.vue";
import sign from "./sign.vue";
import success from "./success.vue";

export default {
  components: {
    basicInfo,
    addr,
    employment,
    sign,
    success,
    esign,
  },
  data() {
    return {
      STATES: ["basicInfo", "address", "employment", "sign", "success"],
      state: 0,
      errorMessage: "",
      applicationData: {},
      submitted: false,
    };
  },
  methods: {
    onNext(data) {
      console.log(data);
      this.applicationData = { ...this.applicationData, ...data };
      if (this.state == 4) this.recaptcha();
      else if (this.state < this.STATES.length) this.state += 1;
    },
    onPrev() {
      if (this.state > 0) this.state -= 1;
    },
    recaptcha() {
      let self = this;
      if (!this.submitted) {
        this.submitted = true;
        this.$recaptcha("apply").then((token) => {
          this.axios
            .post(
              "https://apps.retailcreditcloudapi.net/api/online/application",
              {
                orgId: 5,
                recaptcha_response: token,
                ...self.applicationData,
              }
            )
            .then(
              function({ data }) {
                self.submitted = false;
                localStorage.data = data.data;
                self.$socket.client.emit("handshake", localStorage.data);
                self.state += 1;
              },
              function() {
                self.submitted = false;
                self.errorMessage =
                  "We could not process your application at this time";
                // self.errorMessage = error.message;
              }
            );
        });
      }
    },
    mounted() {
      if (localStorage.data)
        self.$socket.client.emit("reconnect", localStorage.data);
    },
  },
};
</script>
<style></style>
